import api from './api';

export const siteVisitService = {
  getAll: async (params = {}) => {
    const response = await api.get('/site-visits', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/site-visits/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/site-visits', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/site-visits/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/site-visits/${id}`);
    return response.data;
  },

  complete: async (id, data) => {
    const response = await api.put(`/site-visits/${id}/complete`, data);
    return response.data;
  },

  updatePayment: async (id, data) => {
    const response = await api.put(`/site-visits/${id}/payment`, data);
    return response.data;
  },

  getDashboardStats: async () => {
    const response = await api.get('/site-visits/stats/dashboard');
    return response.data;
  },
};

export default siteVisitService;
